import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analyticsTracker';

/**
 * ติดตาม page view อัตโนมัติเมื่อเปลี่ยน route
 * ไม่ track หน้า admin เพื่อไม่ให้ตัวเลขรายงานเพี้ยนจากผู้ดูแลระบบ
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const lastPathRef = useRef('');

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;

    // admin/login ไม่นับ; topicdetail ให้ TopicDetail บันทึกเองพร้อมชื่อหมวดหมู่
    if (
      path.startsWith('/admin') ||
      path.startsWith('/login') ||
      path.startsWith('/topicdetail/')
    ) {
      return;
    }

    if (lastPathRef.current === path) {
      return;
    }

    lastPathRef.current = path;
    trackPageView(path);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
